import React, { Fragment } from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import ourTeams from './HmTeams';
import $ from 'jquery';
// ES6 classNameNameNameName-style
class Founders extends PreLoginSessionCheck {

	constructor(props) {
		super(props);
		this.handleMouseOver = this.handleMouseOver.bind(this);
		this.handleMouseOut = this.handleMouseOut.bind(this);
		this.state = {
			teamperPage: [],
			page: 0,
			data: [],
			paginatedourTeams: []
		}
	}

	componentDidMount() {
		var me = this;
		me.setPage();
	}
	nextPage = () => {
		var me = this;
		var teamdiv = $(".teamimgcontainer");
		teamdiv.animate({ left: '-500px', opacity: '0' }, "fast").promise().done(function () {
			teamdiv.css("left", "500px");
			teamdiv.css("opacity", "0.5");
			me.setState(state => {
				let nextPage = state.page + 1
				if (nextPage > state.data.length - 1) {
					nextPage = 0
				}
				return {
					page: nextPage
				}
			}, () => {
				me.setPage()
			})
			teamdiv.animate({ left: '0px', opacity: '1' }, "fast")
		})
	}

	prevPage = () => {
		var me = this;
		var teamdiv = $(".teamimgcontainer");
		teamdiv.animate({ left: '500px', opacity: '0' }, "fast").promise().done(function () {
			teamdiv.css("left", "-500px");
			teamdiv.css("opacity", "1");
			me.setState((state) => {
				let prevPage = state.page - 1
				if (prevPage < 0) {
					prevPage = state.data.length - 1
				}
				return {
					page: prevPage
				}
			}, () => {
				me.setPage()
			})
			teamdiv.animate({ left: '0px', opacity: '1' }, "fast")
		})
	}

	/* handlePage = (index) => {
		this.setPage(index)
	} */
	setPage = () => {
		const data = this.useFetch();
		this.setState({
			data: data,
		})

		const teamperPage = data[this.state.page];
		this.setState({
			teamperPage: teamperPage
		})
	}

	handleMouseOver(event) {
		var index = $(event.currentTarget).attr("data-index");
		$(".caption-" + index).width($("#profilepic-" + index).width())
		$(".caption-" + index).show();
	}

	handleMouseOut(event) {
		var index = $(event.currentTarget).attr("data-index");
		$(".caption-" + index).hide();
	}

	alttxtFn(a, b) {
		return a + ", " + b;
	}

	useFetch = () => {
		const data = this.paginate(ourTeams);
		this.setState({
			paginatedourTeams: data
		})
		return data
	}

	paginate = (ourTeams) => {
		let itemsPerPage = 15;
		if (this.isMobile() == true && this.isTab() == false) {
			itemsPerPage = 3
		} else if (this.isMobile() == true && this.isTab() == true) {
			itemsPerPage = 9
		} else {
			if (window.innerWidth == 768 || window.innerWidth == 1024) {
				itemsPerPage = 9
			} else {
				itemsPerPage = 15
			}

		}
		const numberOfPages = Math.ceil(ourTeams.length / itemsPerPage)
		const newspiltedteamPage = Array.from({ length: numberOfPages }, (_, index) => {
			const start = index * itemsPerPage
			return ourTeams.slice(start, start + itemsPerPage)
		})
		return newspiltedteamPage
	}
	showButtons = () => {
		if (this.state.paginatedourTeams.length > 1) {
			return (
				<Fragment>
					<button className='prev-btn swiper-button-prev swp-prev' onClick={this.prevPage}>
					</button>
					<button className='next-btn swiper-button-next swp-next' onClick={this.nextPage}>
					</button>
				</Fragment>
			)
		}
	}
	callforDesktop = (teamperPage) => {
		return (
			teamperPage.map((element, index) => {
				return (
					<a className="profile" key={index}>
						<figure>
							<div id={"profilepic-" + element.id} className="profile-pic" data-index={element.id} style={{ color: "#ccc", background: 'url("../../images/teamHM/' + element.picture + '")' }} role='img' aria-label={this.alttxtFn(element.name, element.desgn)} onClick={this.handleMouseOver} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}></div>
							<figcaption className={"caption-" + element.id}>
								<h5>{element.name}</h5>
								<h6>{element.desgn}</h6>
							</figcaption>
						</figure>
					</a>
				);
			})
		)
	}
	callforMobile = (teamperPage) => {
		return (
			teamperPage.map((element, index) => {
				return (
					<a className="profile profileformobile" key={index}>
						<figure>
							<div id={"profilepic-" + element.id} className="profile-pic" data-index={element.id} style={{ color: "#ccc", background: 'url("../../images/teamHM/' + element.picture + '")' }} role='img' aria-label={this.alttxtFn(element.name, element.desgn)} onClick={this.handleMouseOver} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}></div>
							<figcaption className={"caption-" + element.id}>
								<h5>{element.name}</h5>
								<h6>{element.desgn}</h6>
							</figcaption>
						</figure>
					</a>
				);
			})
		)
	}
	callforIpad = (teamperPage) => {
		return (
			teamperPage.map((element, index) => {
				return (
					<a className="profile profileforipad" key={index}>
						<figure>
							<div id={"profilepic-" + element.id} className="profile-pic" data-index={element.id} style={{ color: "#ccc", background: 'url("../../images/teamHM/' + element.picture + '")' }} role='img' aria-label={this.alttxtFn(element.name, element.desgn)} onClick={this.handleMouseOver} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}></div>
							<figcaption className={"caption-" + element.id}>
								<h5>{element.name}</h5>
								<h6>{element.desgn}</h6>
							</figcaption>
						</figure>
					</a>
				);
			})
		)
	}
	checkforDevice = (teamperPage) => {
		if (this.isMobile() == true && this.isTab() == false) {
			return this.callforMobile(teamperPage)
		} else if (this.isMobile() == true && this.isTab() == true) {
			return this.callforIpad(teamperPage)
		} else {
			return this.callforDesktop(teamperPage)
		}
	}
	renderpages = () => {
		const teamperPage = this.state.teamperPage;
		return (
			< section className="mtb product-main founder" >
				<div className="container ourteamcontainer">
					<div className="">
						<div className="col-12 row d-flex flex-center teamimgcontainer ourteammaincontainer">
							{
								this.checkforDevice(teamperPage)
							}
						</div>
					</div>
					{
						this.showButtons()
					}
				</div >
			</section >
		);
	}
	render() {
		const teamperPage = this.state.teamperPage;
		if (this.state.teamperPage && this.state.teamperPage.length > 0) {
			return this.renderpages();
		} else {
			return this.showLoader()
		}
	}
}

export default Founders;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/OurTeam.js